<template>
  <div class="flex h-full items-center max-lg:py-2">
    <SFButton
      ref="button"
      :aria-label="
        $t('shop_selector.aria_label', {
          selectedCountry,
          selectedLanguage,
        })
      "
      :listbox-button-aria-id="listboxButtonAriaId"
      aria-haspopup="true"
      class="group h-full gap-2 !text-gray-600 -outline-offset-5 transition duration-100 ease-linear hover:!text-orange-500 focus-visible:shadow-inner-solid lg:!text-white"
      data-testid="language-listbox"
      variant="raw"
      @click="toggle"
    >
      <IconGlobe
        class="shrink-0 transition-colors duration-100 xs:size-5 md:size-6"
        data-testid="shop-switcher-globe-icon"
      />
      <div
        class="font-sans text-lg font-bold lg:text-sm"
        data-testid="shop-switcher-current-shop"
      >
        {{ selectedLanguageCode }}
      </div>
    </SFButton>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useCurrentShop } from '#storefront/composables'
import { SFButton } from '#storefront-ui/components'
import { useSlideIn } from '~/modules/ui/runtime/composables/useSlideIn'
import { useCurrentShopTranslators } from '~/composables/useCurrentShopTranslators'
// import { hasMultipleShopsForCountry } from '~/utils'

const currentShop = useCurrentShop()
// const availableShops = useAvailableShops()

const { toggle } = useSlideIn('ShopSwitcherSlideIn')

const { languageTranslator, regionTranslator } = useCurrentShopTranslators()

const selectedLanguageCode = computed(() => {
  if (!currentShop.value) {
    return
  }
  const [language] = currentShop.value.locale.split('-')
  return language?.toUpperCase()
})

const selectedLanguage = computed(() => {
  if (!currentShop.value) {
    return
  }
  const [language] = currentShop.value.locale.split('-')
  return languageTranslator.value?.of(language)
})

const selectedCountry = computed(() => {
  if (!currentShop.value) {
    return
  }
  const [, region] = currentShop.value.locale.split('-')

  return region ? regionTranslator.value?.of(region) : null
})

// const multipleShopsForCountry = computed(() =>
//   hasMultipleShopsForCountry(availableShops.value),
// )
defineProps<{
  listboxButtonAriaId: string
}>()
</script>
